import { BrowserRouter as Router } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FixedActionButtons from "./components/FixedActionButtons";
import AnimatedRoutes from "./components/AnimatedRoutes";

function App() {
  const handleContactClick = () => {
    // Custom logic to open contact modal or redirect
    console.log("Open contact form/modal here");
  };

  return (
    <Router>
      <Header />
      <ScrollToTop />
      <AnimatedRoutes />{" "}
      <FixedActionButtons onContactClick={handleContactClick} />
      <Footer />
    </Router>
  );
}

export default App;
